export default "__VITE_ASSET__f_dOILz1__"